<ui-object-navigation-main-page alias="te"></ui-object-navigation-main-page>